import { render, staticRenderFns } from "./index.vue?vue&type=template&id=43accfad&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43accfad",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/suifeng/Desktop/projects/2023/thShop/thShopAdmin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('43accfad')) {
      api.createRecord('43accfad', component.options)
    } else {
      api.reload('43accfad', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=43accfad&scoped=true&", function () {
      api.rerender('43accfad', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/reports/product/index.vue"
export default component.exports